import React from "react";
import { ColorResult } from "react-color";
import styles from "./styles.module.scss";
import {ColorPicker as PopColorPicker} from 'src/components/color'

interface ColorPickerProps {
  title: string;
  hexColor: string;
  onColorChange: (color: string) => void;
}

const ColorPicker: React.FC<ColorPickerProps> = ({
  title,
  hexColor,
  onColorChange,
}) => {

  // Methods
  const handleChange = (color: ColorResult) => {
    onColorChange(color.hex);
  };

  return (
    <div className={styles.container}>
       <PopColorPicker
                  color={hexColor}
                  onChange={(color: any) => {
                    handleChange(color);
                  }}
                  disableAlpha={true}
        >

                <div className={styles.innercontainer}>
                  <div
                    className={styles.hexCode}
                    style={{ background: hexColor }}
                  ></div>
                  <div className={styles.colorPicker}>
                      <p>{title}</p>
                      <span className={styles.colorCode}>{hexColor}</span>
                  </div>
                </div>

          </PopColorPicker>
    </div>
  );
};

export default ColorPicker;
